// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-workbook-create-entry__icon-connection {
  color: var(--g-color-text-utility);
}
.dl-workbook-create-entry__dropdown-item {
  display: flex;
  align-items: center;
}
.dl-workbook-create-entry__dropdown-text {
  margin-left: 8px;
}
.dl-workbook-create-entry__shared-entry-notice {
  margin: 4px -4px 8px;
  cursor: initial;
}
.dl-workbook-create-entry__shared-entry-notice:hover {
  background-color: initial;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/workbooks/components/CreateEntry/CreateEntry.scss"],"names":[],"mappings":"AACI;EACI,kCAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;AADR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,oBAAA;EACA,eAAA;AAHR;AAIQ;EACI,yBAAA;AAFZ","sourcesContent":[".dl-workbook-create-entry__icon-connection {\n  color: var(--g-color-text-utility);\n}\n.dl-workbook-create-entry__dropdown-item {\n  display: flex;\n  align-items: center;\n}\n.dl-workbook-create-entry__dropdown-text {\n  margin-left: 8px;\n}\n.dl-workbook-create-entry__shared-entry-notice {\n  margin: 4px -4px 8px;\n  cursor: initial;\n}\n.dl-workbook-create-entry__shared-entry-notice:hover {\n  background-color: initial;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
